import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, Validators ,UntypedFormBuilder } from '@angular/forms';
import {ShareMapService} from '../share-map.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'
@Component({
  selector: 'app-protected-modal',
  templateUrl: './protected-modal.component.html',
  styleUrls: ['./protected-modal.component.css']
})
export class ProtectedModalComponent implements OnInit {
  passwordProtectedForm: UntypedFormGroup;
  share_id: any;
  showErrorMessage = false;
  password_hide = true;
  shareMode: any;
  constructor(private MatDialog:MatDialog,public dialogRef: MatDialogRef<ProtectedModalComponent>,private ShareMapService :ShareMapService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private formBuilder:UntypedFormBuilder,private router :Router) { 
      this.share_id = data.shareId
      console.log(this.share_id);
      this.shareMode = data.shareMode 
    }

  ngOnInit() {
    this.passwordProtectedForm = this.formBuilder.group({
      password: ['', Validators.required]
    });
    }
  get p(){return this.passwordProtectedForm.controls }

  closepasswordModal(): void {
    this.dialogRef.close();
  }

  passwordSubmit(){

    this.ShareMapService.getShareMapDetails(this.share_id,this.p.password.value).subscribe(data=>{
      if(data.data.match==false){
        this.showErrorMessage = true; 
      }
      else{
        this.showErrorMessage = false
        this.dialogRef.close(data)
      }
      console.log(data);
      
        });
  }
  privateUserNavigate(){
    this.dialogRef.close()
    this.router.navigateByUrl('/analysis')
    // const dialogRef=this.MatDialog.open(LoginSignupModalComponent,{
    //   width:'75%',
    //   data:{loginModel:true}

    // });
  }

}
